import React from 'react';
import { Helmet } from 'react-helmet';

type Props = {
  type: Page;
  title: string;
  desc: string;
  image: string;
  siteMetadata: GatsbyTypes.SiteSiteMetadata;
};

const Meta: React.VFC<Props> = ({ type, title, desc, image, siteMetadata }) => (
  <Helmet>
    <html lang="ja" />
    <title>{title}</title>
    <meta name="description" content={desc} />
    <meta property="og:site_name" content={title} />
    <meta property="og:image" content={siteMetadata.siteUrl + image} />
    <meta
      name="twitter:card"
      content={type === `work` ? `summary_large_image` : `summary`}
    />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={desc} />
    <meta name="twitter:image" content={siteMetadata.siteUrl + image} />
  </Helmet>
);

export default Meta;
